import React from 'react'

import s from './styles.module.scss'

import { Image } from '../../../components/atoms/containers'

const PwaRedirect = () => {
  return (
    <div className={s.container}>
      <div className={s.illustration}></div>
      <div className={s.content}>
        <div className={s.logo}>
          <Image src='/images/logo-naboo.svg' alt='' type='contain' />
        </div>

        <div className={s.card}>
          <div className={s.form}>
            <h2 className={s.title}>
              Accédez à votre espace depuis un ordinateur
            </h2>
            <div className={s.description}>
              La version mobile de notre application web est en cours de
              développement et sera disponible prochainement.
            </div>
            <div className={s.description}>
              Nous vous invitons à vous connecter depuis un navigateur internet
              sur ordinateur.
            </div>
            <div className={s.description}></div>Veuillez nous excuser pour ce
            désagrément et à très vite sur Naboo !
          </div>
        </div>
      </div>
    </div>
  )
}

export default PwaRedirect
